import React, { useState } from 'react';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    email: '',
    subject: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    // Check if running on localhost
    if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
      console.warn('⚠️ API routes (/api/contact) do not work with "npm start". You must use "vercel dev" or deploy to Vercel to test the contact form.');
    }

    try {
      const response = await fetch('/api/contact', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({ email: '', subject: '', message: '' });
      } else {
        const errorData = await response.json().catch(() => ({}));
        console.error('Server responded with error:', response.status, response.statusText, errorData);
        setSubmitStatus('error');
      }
    } catch (error) {
      console.error('Error sending message:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className="contact">
      <div className="container">
        <h2 className="section-title">Contact Us</h2>
        <p className="section-subtitle">
          Have questions about LunarLog AI? We'd love to hear from you. Send us a message and we'll respond as soon as possible.
        </p>
        
        <div className="contact-content">
          <div className="contact-form-container">
            <form onSubmit={handleSubmit} className="contact-form">
              <div className="form-group">
                <label htmlFor="email">EMAIL</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  placeholder="your@email.com"
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="subject">SUBJECT</label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                  placeholder="What's this about?"
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="message">MESSAGE</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  placeholder="Tell us more..."
                  rows="6"
                />
              </div>
              
              <button 
                type="submit" 
                className="btn btn-primary send-message-btn"
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Sending...' : 'SEND MESSAGE'}
              </button>
            </form>
            
            {submitStatus === 'success' && (
              <div className="success-message">
                <p>Thank you! Your message has been sent successfully. We'll get back to you soon.</p>
              </div>
            )}
            
            {submitStatus === 'error' && (
              <div className="error-message">
                <p>Sorry, there was an error sending your message. Please try again or contact us directly.</p>
              </div>
            )}
          </div>
          
          <div className="contact-info">
            <div className="info-card">
              <h3>Get in Touch</h3>
              <p>We're here to help with any questions about LunarLog AI, trading strategies, or technical support.</p>
              
              <div className="contact-details">
                <div className="contact-item">
                  <h4>Email</h4>
                  <p>support@lunarlogai.com</p>
                </div>
                
                <div className="contact-item">
                  <h4>Response Time</h4>
                  <p>We typically respond within 24 hours</p>
                </div>
                
                <div className="contact-item">
                  <h4>Business Hours</h4>
                  <p>Monday - Friday: 9 AM - 6 PM EST</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
